import { render, staticRenderFns } from "./InputMultiChoice.vue?vue&type=template&id=ea15c32c&"
import script from "./InputMultiChoice.vue?vue&type=script&lang=ts&"
export * from "./InputMultiChoice.vue?vue&type=script&lang=ts&"
import style0 from "./InputMultiChoice.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports